import { render, staticRenderFns } from "./CancelCustomerOrderModal.vue?vue&type=template&id=1b7fbb18&scoped=true&"
import script from "./CancelCustomerOrderModal.vue?vue&type=script&lang=ts&"
export * from "./CancelCustomerOrderModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7fbb18",
  null
  
)

export default component.exports